/**
 * @fileoverview gRPC-Web generated client stub for ticketepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/ticket/collection.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_collection_pb = require('../../xcommon/collection_pb.js')

var xcommon_ticket_pb = require('../../xcommon/ticket_pb.js')

var xcommon_phonesale_pb = require('../../xcommon/phonesale_pb.js')
const proto = {};
proto.ticketepb = require('./collection_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.ticketepb.CollectionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.ticketepb.CollectionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVerifyTicketListParamReq,
 *   !proto.xcommon.GetVerifyTicketListParamResp>}
 */
const methodDescriptor_CollectionService_GetVerifyTicketListParam = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetVerifyTicketListParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetVerifyTicketListParamReq,
  xcommon_ticket_pb.GetVerifyTicketListParamResp,
  /**
   * @param {!proto.xcommon.GetVerifyTicketListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVerifyTicketListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVerifyTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetVerifyTicketListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVerifyTicketListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getVerifyTicketListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVerifyTicketListParam',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVerifyTicketListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetVerifyTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVerifyTicketListParamResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getVerifyTicketListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVerifyTicketListParam',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVerifyTicketListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVerifyListReq,
 *   !proto.xcommon.GetVerifyListResp>}
 */
const methodDescriptor_CollectionService_GetVerifyList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetVerifyList',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetVerifyListReq,
  xcommon_collection_pb.GetVerifyListResp,
  /**
   * @param {!proto.xcommon.GetVerifyListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetVerifyListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVerifyListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetVerifyListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVerifyListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getVerifyList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVerifyList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVerifyList,
      callback);
};


/**
 * @param {!proto.xcommon.GetVerifyListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVerifyListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getVerifyList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVerifyList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVerifyList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOverdueListParamReq,
 *   !proto.xcommon.GetOverdueListParamResp>}
 */
const methodDescriptor_CollectionService_GetOverdueListParam = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetOverdueListParam',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetOverdueListParamReq,
  xcommon_collection_pb.GetOverdueListParamResp,
  /**
   * @param {!proto.xcommon.GetOverdueListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetOverdueListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOverdueListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetOverdueListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOverdueListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getOverdueListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOverdueListParam',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOverdueListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetOverdueListParamReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOverdueListParamResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getOverdueListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOverdueListParam',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOverdueListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRemindListReq,
 *   !proto.xcommon.GetRemindListResp>}
 */
const methodDescriptor_CollectionService_GetRemindList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetRemindList',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetRemindListReq,
  xcommon_collection_pb.GetRemindListResp,
  /**
   * @param {!proto.xcommon.GetRemindListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetRemindListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRemindListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetRemindListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRemindListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getRemindList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRemindList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRemindList,
      callback);
};


/**
 * @param {!proto.xcommon.GetRemindListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRemindListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getRemindList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRemindList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRemindList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOverdueListReq,
 *   !proto.xcommon.GetOverdueListResp>}
 */
const methodDescriptor_CollectionService_GetOverdueList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetOverdueList',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetOverdueListReq,
  xcommon_collection_pb.GetOverdueListResp,
  /**
   * @param {!proto.xcommon.GetOverdueListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetOverdueListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOverdueListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetOverdueListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOverdueListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getOverdueList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOverdueList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOverdueList,
      callback);
};


/**
 * @param {!proto.xcommon.GetOverdueListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOverdueListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getOverdueList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOverdueList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOverdueList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRemindCaseReq,
 *   !proto.xcommon.GetRemindCaseResp>}
 */
const methodDescriptor_CollectionService_GetRemindCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetRemindCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetRemindCaseReq,
  xcommon_collection_pb.GetRemindCaseResp,
  /**
   * @param {!proto.xcommon.GetRemindCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetRemindCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRemindCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetRemindCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRemindCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getRemindCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRemindCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRemindCase,
      callback);
};


/**
 * @param {!proto.xcommon.GetRemindCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRemindCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getRemindCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRemindCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRemindCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOverdueCaseReq,
 *   !proto.xcommon.GetOverdueCaseResp>}
 */
const methodDescriptor_CollectionService_GetOverdueCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetOverdueCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetOverdueCaseReq,
  xcommon_collection_pb.GetOverdueCaseResp,
  /**
   * @param {!proto.xcommon.GetOverdueCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetOverdueCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOverdueCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetOverdueCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOverdueCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getOverdueCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOverdueCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOverdueCase,
      callback);
};


/**
 * @param {!proto.xcommon.GetOverdueCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOverdueCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getOverdueCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOverdueCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOverdueCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveRemindCaseReq,
 *   !proto.xcommon.SaveRemindCaseResp>}
 */
const methodDescriptor_CollectionService_SaveRemindCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveRemindCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SaveRemindCaseReq,
  xcommon_collection_pb.SaveRemindCaseResp,
  /**
   * @param {!proto.xcommon.SaveRemindCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SaveRemindCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveRemindCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveRemindCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveRemindCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveRemindCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveRemindCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveRemindCase,
      callback);
};


/**
 * @param {!proto.xcommon.SaveRemindCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveRemindCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveRemindCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveRemindCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveRemindCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveOverdueCaseReq,
 *   !proto.xcommon.SaveOverdueCaseResp>}
 */
const methodDescriptor_CollectionService_SaveOverdueCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveOverdueCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SaveOverdueCaseReq,
  xcommon_collection_pb.SaveOverdueCaseResp,
  /**
   * @param {!proto.xcommon.SaveOverdueCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SaveOverdueCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveOverdueCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveOverdueCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveOverdueCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveOverdueCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveOverdueCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveOverdueCase,
      callback);
};


/**
 * @param {!proto.xcommon.SaveOverdueCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveOverdueCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveOverdueCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveOverdueCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveOverdueCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetReductionListReq,
 *   !proto.xcommon.GetReductionListResp>}
 */
const methodDescriptor_CollectionService_GetReductionList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetReductionList',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetReductionListReq,
  xcommon_collection_pb.GetReductionListResp,
  /**
   * @param {!proto.xcommon.GetReductionListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetReductionListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetReductionListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetReductionListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetReductionListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getReductionList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetReductionList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetReductionList,
      callback);
};


/**
 * @param {!proto.xcommon.GetReductionListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetReductionListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getReductionList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetReductionList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetReductionList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetPhoneObjectsReq,
 *   !proto.xcommon.GetPhoneObjectsResp>}
 */
const methodDescriptor_CollectionService_GetPhoneObjects = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetPhoneObjects',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetPhoneObjectsReq,
  xcommon_collection_pb.GetPhoneObjectsResp,
  /**
   * @param {!proto.xcommon.GetPhoneObjectsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetPhoneObjectsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetPhoneObjectsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetPhoneObjectsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetPhoneObjectsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getPhoneObjects =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneObjects',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneObjects,
      callback);
};


/**
 * @param {!proto.xcommon.GetPhoneObjectsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetPhoneObjectsResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getPhoneObjects =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneObjects',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneObjects);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetCustomerDetailReq,
 *   !proto.xcommon.GetCustomerDetailResp>}
 */
const methodDescriptor_CollectionService_GetCustomerDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetCustomerDetail',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetCustomerDetailReq,
  xcommon_collection_pb.GetCustomerDetailResp,
  /**
   * @param {!proto.xcommon.GetCustomerDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetCustomerDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetCustomerDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetCustomerDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetCustomerDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getCustomerDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCustomerDetail',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCustomerDetail,
      callback);
};


/**
 * @param {!proto.xcommon.GetCustomerDetailReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetCustomerDetailResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getCustomerDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCustomerDetail',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCustomerDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetSmsTaskIdMapReq,
 *   !proto.xcommon.GetSmsTaskIdMapResp>}
 */
const methodDescriptor_CollectionService_GetSmsTaskIdMap = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetSmsTaskIdMap',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetSmsTaskIdMapReq,
  xcommon_collection_pb.GetSmsTaskIdMapResp,
  /**
   * @param {!proto.xcommon.GetSmsTaskIdMapReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetSmsTaskIdMapResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetSmsTaskIdMapReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetSmsTaskIdMapResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetSmsTaskIdMapResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getSmsTaskIdMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetSmsTaskIdMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetSmsTaskIdMap,
      callback);
};


/**
 * @param {!proto.xcommon.GetSmsTaskIdMapReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetSmsTaskIdMapResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getSmsTaskIdMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetSmsTaskIdMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetSmsTaskIdMap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SendSmsByTaskIdReq,
 *   !proto.xcommon.SendSmsByTaskIdResp>}
 */
const methodDescriptor_CollectionService_SendSmsByTaskId = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SendSmsByTaskId',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SendSmsByTaskIdReq,
  xcommon_collection_pb.SendSmsByTaskIdResp,
  /**
   * @param {!proto.xcommon.SendSmsByTaskIdReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SendSmsByTaskIdResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SendSmsByTaskIdReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SendSmsByTaskIdResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SendSmsByTaskIdResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.sendSmsByTaskId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SendSmsByTaskId',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SendSmsByTaskId,
      callback);
};


/**
 * @param {!proto.xcommon.SendSmsByTaskIdReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SendSmsByTaskIdResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.sendSmsByTaskId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SendSmsByTaskId',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SendSmsByTaskId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUrgeLetterMapReq,
 *   !proto.xcommon.GetUrgeLetterMapResp>}
 */
const methodDescriptor_CollectionService_GetUrgeLetterMap = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetUrgeLetterMap',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetUrgeLetterMapReq,
  xcommon_collection_pb.GetUrgeLetterMapResp,
  /**
   * @param {!proto.xcommon.GetUrgeLetterMapReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetUrgeLetterMapResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUrgeLetterMapReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetUrgeLetterMapResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetUrgeLetterMapResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getUrgeLetterMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetUrgeLetterMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetUrgeLetterMap,
      callback);
};


/**
 * @param {!proto.xcommon.GetUrgeLetterMapReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetUrgeLetterMapResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getUrgeLetterMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetUrgeLetterMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetUrgeLetterMap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DownloadUrgeLetterReq,
 *   !proto.xcommon.DownloadUrgeLetterResp>}
 */
const methodDescriptor_CollectionService_DownloadUrgeLetter = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/DownloadUrgeLetter',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.DownloadUrgeLetterReq,
  xcommon_collection_pb.DownloadUrgeLetterResp,
  /**
   * @param {!proto.xcommon.DownloadUrgeLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.DownloadUrgeLetterResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DownloadUrgeLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.DownloadUrgeLetterResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DownloadUrgeLetterResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.downloadUrgeLetter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/DownloadUrgeLetter',
      request,
      metadata || {},
      methodDescriptor_CollectionService_DownloadUrgeLetter,
      callback);
};


/**
 * @param {!proto.xcommon.DownloadUrgeLetterReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DownloadUrgeLetterResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.downloadUrgeLetter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/DownloadUrgeLetter',
      request,
      metadata || {},
      methodDescriptor_CollectionService_DownloadUrgeLetter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UpdateMarketPaymentCodeAmountReq,
 *   !proto.xcommon.UpdateMarketPaymentCodeAmountResp>}
 */
const methodDescriptor_CollectionService_UpdateMarketPaymentCodeAmount = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/UpdateMarketPaymentCodeAmount',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.UpdateMarketPaymentCodeAmountReq,
  xcommon_collection_pb.UpdateMarketPaymentCodeAmountResp,
  /**
   * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.UpdateMarketPaymentCodeAmountResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.UpdateMarketPaymentCodeAmountResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.UpdateMarketPaymentCodeAmountResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.updateMarketPaymentCodeAmount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/UpdateMarketPaymentCodeAmount',
      request,
      metadata || {},
      methodDescriptor_CollectionService_UpdateMarketPaymentCodeAmount,
      callback);
};


/**
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.UpdateMarketPaymentCodeAmountResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.updateMarketPaymentCodeAmount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/UpdateMarketPaymentCodeAmount',
      request,
      metadata || {},
      methodDescriptor_CollectionService_UpdateMarketPaymentCodeAmount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CalcMarketPaymentCodeFeeReq,
 *   !proto.xcommon.CalcMarketPaymentCodeFeeResp>}
 */
const methodDescriptor_CollectionService_CalcMarketPaymentCodeFee = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/CalcMarketPaymentCodeFee',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.CalcMarketPaymentCodeFeeReq,
  xcommon_collection_pb.CalcMarketPaymentCodeFeeResp,
  /**
   * @param {!proto.xcommon.CalcMarketPaymentCodeFeeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.CalcMarketPaymentCodeFeeResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CalcMarketPaymentCodeFeeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CalcMarketPaymentCodeFeeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.calcMarketPaymentCodeFee =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/CalcMarketPaymentCodeFee',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CalcMarketPaymentCodeFee,
      callback);
};


/**
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CalcMarketPaymentCodeFeeResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.calcMarketPaymentCodeFee =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/CalcMarketPaymentCodeFee',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CalcMarketPaymentCodeFee);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CasePageTurningReq,
 *   !proto.xcommon.CasePageTurningResp>}
 */
const methodDescriptor_CollectionService_CasePageTurning = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/CasePageTurning',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.CasePageTurningReq,
  xcommon_collection_pb.CasePageTurningResp,
  /**
   * @param {!proto.xcommon.CasePageTurningReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.CasePageTurningResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CasePageTurningReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CasePageTurningResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CasePageTurningResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.casePageTurning =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/CasePageTurning',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CasePageTurning,
      callback);
};


/**
 * @param {!proto.xcommon.CasePageTurningReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CasePageTurningResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.casePageTurning =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/CasePageTurning',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CasePageTurning);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UpdateCustomerSalaryInfoReq,
 *   !proto.xcommon.UpdateCustomerSalaryInfoResp>}
 */
const methodDescriptor_CollectionService_UpdateCustomerSalaryInfo = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/UpdateCustomerSalaryInfo',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.UpdateCustomerSalaryInfoReq,
  xcommon_collection_pb.UpdateCustomerSalaryInfoResp,
  /**
   * @param {!proto.xcommon.UpdateCustomerSalaryInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.UpdateCustomerSalaryInfoResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.UpdateCustomerSalaryInfoResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.UpdateCustomerSalaryInfoResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.updateCustomerSalaryInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/UpdateCustomerSalaryInfo',
      request,
      metadata || {},
      methodDescriptor_CollectionService_UpdateCustomerSalaryInfo,
      callback);
};


/**
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.UpdateCustomerSalaryInfoResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.updateCustomerSalaryInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/UpdateCustomerSalaryInfo',
      request,
      metadata || {},
      methodDescriptor_CollectionService_UpdateCustomerSalaryInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveRiskReportReq,
 *   !proto.xcommon.SaveRiskReportResp>}
 */
const methodDescriptor_CollectionService_SaveRiskReport = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveRiskReport',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SaveRiskReportReq,
  xcommon_collection_pb.SaveRiskReportResp,
  /**
   * @param {!proto.xcommon.SaveRiskReportReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SaveRiskReportResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveRiskReportReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveRiskReportResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveRiskReportResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveRiskReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveRiskReport',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveRiskReport,
      callback);
};


/**
 * @param {!proto.xcommon.SaveRiskReportReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveRiskReportResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveRiskReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveRiskReport',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveRiskReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveContactReq,
 *   !proto.xcommon.SaveContactResp>}
 */
const methodDescriptor_CollectionService_SaveContact = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveContact',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SaveContactReq,
  xcommon_collection_pb.SaveContactResp,
  /**
   * @param {!proto.xcommon.SaveContactReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SaveContactResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveContactReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveContactResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveContactResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveContact',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveContact,
      callback);
};


/**
 * @param {!proto.xcommon.SaveContactReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveContactResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveContact',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWhatsAppMsgMapReq,
 *   !proto.xcommon.GetWhatsAppMsgMapResp>}
 */
const methodDescriptor_CollectionService_GetWhatsAppMsgMap = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetWhatsAppMsgMap',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetWhatsAppMsgMapReq,
  xcommon_collection_pb.GetWhatsAppMsgMapResp,
  /**
   * @param {!proto.xcommon.GetWhatsAppMsgMapReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetWhatsAppMsgMapResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWhatsAppMsgMapReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetWhatsAppMsgMapResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetWhatsAppMsgMapResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getWhatsAppMsgMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetWhatsAppMsgMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetWhatsAppMsgMap,
      callback);
};


/**
 * @param {!proto.xcommon.GetWhatsAppMsgMapReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetWhatsAppMsgMapResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getWhatsAppMsgMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetWhatsAppMsgMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetWhatsAppMsgMap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAllAutoCallResultReq,
 *   !proto.xcommon.GetAllAutoCallResultResp>}
 */
const methodDescriptor_CollectionService_GetAllAutoCallResult = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetAllAutoCallResult',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetAllAutoCallResultReq,
  xcommon_collection_pb.GetAllAutoCallResultResp,
  /**
   * @param {!proto.xcommon.GetAllAutoCallResultReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetAllAutoCallResultResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAllAutoCallResultReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetAllAutoCallResultResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAllAutoCallResultResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getAllAutoCallResult =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetAllAutoCallResult',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetAllAutoCallResult,
      callback);
};


/**
 * @param {!proto.xcommon.GetAllAutoCallResultReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAllAutoCallResultResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getAllAutoCallResult =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetAllAutoCallResult',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetAllAutoCallResult);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetCaseLogDetailReq,
 *   !proto.xcommon.GetCaseLogDetailResp>}
 */
const methodDescriptor_CollectionService_GetCaseLogDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetCaseLogDetail',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetCaseLogDetailReq,
  xcommon_collection_pb.GetCaseLogDetailResp,
  /**
   * @param {!proto.xcommon.GetCaseLogDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetCaseLogDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetCaseLogDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetCaseLogDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetCaseLogDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getCaseLogDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCaseLogDetail',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCaseLogDetail,
      callback);
};


/**
 * @param {!proto.xcommon.GetCaseLogDetailReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetCaseLogDetailResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getCaseLogDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCaseLogDetail',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCaseLogDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CreatePaymentVoucherReq,
 *   !proto.xcommon.CreatePaymentVoucherResp>}
 */
const methodDescriptor_CollectionService_CreatePaymentVoucher = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/CreatePaymentVoucher',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.CreatePaymentVoucherReq,
  xcommon_collection_pb.CreatePaymentVoucherResp,
  /**
   * @param {!proto.xcommon.CreatePaymentVoucherReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.CreatePaymentVoucherResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CreatePaymentVoucherReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CreatePaymentVoucherResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CreatePaymentVoucherResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.createPaymentVoucher =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/CreatePaymentVoucher',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CreatePaymentVoucher,
      callback);
};


/**
 * @param {!proto.xcommon.CreatePaymentVoucherReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CreatePaymentVoucherResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.createPaymentVoucher =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/CreatePaymentVoucher',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CreatePaymentVoucher);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UploadDocumentReq,
 *   !proto.xcommon.UploadDocumentResp>}
 */
const methodDescriptor_CollectionService_UploadDocument = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/UploadDocument',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.UploadDocumentReq,
  xcommon_collection_pb.UploadDocumentResp,
  /**
   * @param {!proto.xcommon.UploadDocumentReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.UploadDocumentResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.UploadDocumentReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.UploadDocumentResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.UploadDocumentResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.uploadDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/UploadDocument',
      request,
      metadata || {},
      methodDescriptor_CollectionService_UploadDocument,
      callback);
};


/**
 * @param {!proto.xcommon.UploadDocumentReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.UploadDocumentResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.uploadDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/UploadDocument',
      request,
      metadata || {},
      methodDescriptor_CollectionService_UploadDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetCustomerOtherMobileReq,
 *   !proto.xcommon.GetCustomerOtherMobileResp>}
 */
const methodDescriptor_CollectionService_GetCustomerOtherMobile = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetCustomerOtherMobile',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetCustomerOtherMobileReq,
  xcommon_collection_pb.GetCustomerOtherMobileResp,
  /**
   * @param {!proto.xcommon.GetCustomerOtherMobileReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetCustomerOtherMobileResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetCustomerOtherMobileReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetCustomerOtherMobileResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetCustomerOtherMobileResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getCustomerOtherMobile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCustomerOtherMobile',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCustomerOtherMobile,
      callback);
};


/**
 * @param {!proto.xcommon.GetCustomerOtherMobileReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetCustomerOtherMobileResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getCustomerOtherMobile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCustomerOtherMobile',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCustomerOtherMobile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetCouponTaskIdMapReq,
 *   !proto.xcommon.GetCouponTaskIdMapResp>}
 */
const methodDescriptor_CollectionService_GetCouponTaskIdMap = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetCouponTaskIdMap',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetCouponTaskIdMapReq,
  xcommon_collection_pb.GetCouponTaskIdMapResp,
  /**
   * @param {!proto.xcommon.GetCouponTaskIdMapReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetCouponTaskIdMapResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetCouponTaskIdMapReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetCouponTaskIdMapResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetCouponTaskIdMapResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getCouponTaskIdMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCouponTaskIdMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCouponTaskIdMap,
      callback);
};


/**
 * @param {!proto.xcommon.GetCouponTaskIdMapReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetCouponTaskIdMapResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getCouponTaskIdMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetCouponTaskIdMap',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetCouponTaskIdMap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SendCouponByTaskIdReq,
 *   !proto.xcommon.SendCouponByTaskIdResp>}
 */
const methodDescriptor_CollectionService_SendCouponByTaskId = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SendCouponByTaskId',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SendCouponByTaskIdReq,
  xcommon_collection_pb.SendCouponByTaskIdResp,
  /**
   * @param {!proto.xcommon.SendCouponByTaskIdReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SendCouponByTaskIdResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SendCouponByTaskIdReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SendCouponByTaskIdResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SendCouponByTaskIdResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.sendCouponByTaskId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SendCouponByTaskId',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SendCouponByTaskId,
      callback);
};


/**
 * @param {!proto.xcommon.SendCouponByTaskIdReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SendCouponByTaskIdResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.sendCouponByTaskId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SendCouponByTaskId',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SendCouponByTaskId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ReduceCreditCardFeeReq,
 *   !proto.xcommon.ReduceCreditCardFeeResp>}
 */
const methodDescriptor_CollectionService_ReduceCreditCardFee = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/ReduceCreditCardFee',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.ReduceCreditCardFeeReq,
  xcommon_collection_pb.ReduceCreditCardFeeResp,
  /**
   * @param {!proto.xcommon.ReduceCreditCardFeeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.ReduceCreditCardFeeResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ReduceCreditCardFeeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ReduceCreditCardFeeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ReduceCreditCardFeeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.reduceCreditCardFee =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/ReduceCreditCardFee',
      request,
      metadata || {},
      methodDescriptor_CollectionService_ReduceCreditCardFee,
      callback);
};


/**
 * @param {!proto.xcommon.ReduceCreditCardFeeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ReduceCreditCardFeeResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.reduceCreditCardFee =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/ReduceCreditCardFee',
      request,
      metadata || {},
      methodDescriptor_CollectionService_ReduceCreditCardFee);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveWhatsappFlagReq,
 *   !proto.xcommon.SaveWhatsappFlagResp>}
 */
const methodDescriptor_CollectionService_SaveWhatsappFlag = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveWhatsappFlag',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SaveWhatsappFlagReq,
  xcommon_collection_pb.SaveWhatsappFlagResp,
  /**
   * @param {!proto.xcommon.SaveWhatsappFlagReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SaveWhatsappFlagResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveWhatsappFlagReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveWhatsappFlagResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveWhatsappFlagResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveWhatsappFlag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveWhatsappFlag',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveWhatsappFlag,
      callback);
};


/**
 * @param {!proto.xcommon.SaveWhatsappFlagReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveWhatsappFlagResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveWhatsappFlag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveWhatsappFlag',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveWhatsappFlag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetPhoneSaleListReq,
 *   !proto.xcommon.GetPhoneSaleListResp>}
 */
const methodDescriptor_CollectionService_GetPhoneSaleList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetPhoneSaleList',
  grpc.web.MethodType.UNARY,
  xcommon_phonesale_pb.GetPhoneSaleListReq,
  xcommon_phonesale_pb.GetPhoneSaleListResp,
  /**
   * @param {!proto.xcommon.GetPhoneSaleListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_phonesale_pb.GetPhoneSaleListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetPhoneSaleListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetPhoneSaleListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetPhoneSaleListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getPhoneSaleList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneSaleList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneSaleList,
      callback);
};


/**
 * @param {!proto.xcommon.GetPhoneSaleListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetPhoneSaleListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getPhoneSaleList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneSaleList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneSaleList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetPhoneSaleCaseReq,
 *   !proto.xcommon.GetPhoneSaleCaseResp>}
 */
const methodDescriptor_CollectionService_GetPhoneSaleCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetPhoneSaleCase',
  grpc.web.MethodType.UNARY,
  xcommon_phonesale_pb.GetPhoneSaleCaseReq,
  xcommon_phonesale_pb.GetPhoneSaleCaseResp,
  /**
   * @param {!proto.xcommon.GetPhoneSaleCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_phonesale_pb.GetPhoneSaleCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetPhoneSaleCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetPhoneSaleCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetPhoneSaleCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getPhoneSaleCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneSaleCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneSaleCase,
      callback);
};


/**
 * @param {!proto.xcommon.GetPhoneSaleCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetPhoneSaleCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getPhoneSaleCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneSaleCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneSaleCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SavePhoneSaleCaseReq,
 *   !proto.xcommon.SavePhoneSaleCaseResp>}
 */
const methodDescriptor_CollectionService_SavePhoneSaleCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SavePhoneSaleCase',
  grpc.web.MethodType.UNARY,
  xcommon_phonesale_pb.SavePhoneSaleCaseReq,
  xcommon_phonesale_pb.SavePhoneSaleCaseResp,
  /**
   * @param {!proto.xcommon.SavePhoneSaleCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_phonesale_pb.SavePhoneSaleCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SavePhoneSaleCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SavePhoneSaleCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SavePhoneSaleCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.savePhoneSaleCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SavePhoneSaleCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SavePhoneSaleCase,
      callback);
};


/**
 * @param {!proto.xcommon.SavePhoneSaleCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SavePhoneSaleCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.savePhoneSaleCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SavePhoneSaleCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SavePhoneSaleCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetPhoneSaleCaseLogReq,
 *   !proto.xcommon.GetPhoneSaleCaseLogResp>}
 */
const methodDescriptor_CollectionService_GetPhoneSaleCaseLog = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetPhoneSaleCaseLog',
  grpc.web.MethodType.UNARY,
  xcommon_phonesale_pb.GetPhoneSaleCaseLogReq,
  xcommon_phonesale_pb.GetPhoneSaleCaseLogResp,
  /**
   * @param {!proto.xcommon.GetPhoneSaleCaseLogReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_phonesale_pb.GetPhoneSaleCaseLogResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetPhoneSaleCaseLogReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetPhoneSaleCaseLogResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetPhoneSaleCaseLogResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getPhoneSaleCaseLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneSaleCaseLog',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneSaleCaseLog,
      callback);
};


/**
 * @param {!proto.xcommon.GetPhoneSaleCaseLogReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetPhoneSaleCaseLogResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getPhoneSaleCaseLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetPhoneSaleCaseLog',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetPhoneSaleCaseLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVoipQICaseListReq,
 *   !proto.xcommon.GetVoipQICaseListResp>}
 */
const methodDescriptor_CollectionService_GetVoipQualityInspectionCaseList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetVoipQualityInspectionCaseList',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetVoipQICaseListReq,
  xcommon_collection_pb.GetVoipQICaseListResp,
  /**
   * @param {!proto.xcommon.GetVoipQICaseListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetVoipQICaseListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVoipQICaseListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetVoipQICaseListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVoipQICaseListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getVoipQualityInspectionCaseList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVoipQualityInspectionCaseList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVoipQualityInspectionCaseList,
      callback);
};


/**
 * @param {!proto.xcommon.GetVoipQICaseListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVoipQICaseListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getVoipQualityInspectionCaseList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVoipQualityInspectionCaseList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVoipQualityInspectionCaseList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVoipQICaseReq,
 *   !proto.xcommon.GetVoipQICaseResp>}
 */
const methodDescriptor_CollectionService_GetVoipQualityInspectionCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetVoipQualityInspectionCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetVoipQICaseReq,
  xcommon_collection_pb.GetVoipQICaseResp,
  /**
   * @param {!proto.xcommon.GetVoipQICaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetVoipQICaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVoipQICaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetVoipQICaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVoipQICaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getVoipQualityInspectionCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVoipQualityInspectionCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVoipQualityInspectionCase,
      callback);
};


/**
 * @param {!proto.xcommon.GetVoipQICaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVoipQICaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getVoipQualityInspectionCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetVoipQualityInspectionCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetVoipQualityInspectionCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveVoipQICaseReq,
 *   !proto.xcommon.SaveVoipQICaseResp>}
 */
const methodDescriptor_CollectionService_SaveVoipQualityInspectionCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveVoipQualityInspectionCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SaveVoipQICaseReq,
  xcommon_collection_pb.SaveVoipQICaseResp,
  /**
   * @param {!proto.xcommon.SaveVoipQICaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SaveVoipQICaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveVoipQICaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveVoipQICaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveVoipQICaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveVoipQualityInspectionCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveVoipQualityInspectionCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveVoipQualityInspectionCase,
      callback);
};


/**
 * @param {!proto.xcommon.SaveVoipQICaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveVoipQICaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveVoipQualityInspectionCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveVoipQualityInspectionCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveVoipQualityInspectionCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRepayReportInfoReq,
 *   !proto.xcommon.GetRepayReportInfoResp>}
 */
const methodDescriptor_CollectionService_GetRepayReportInfo = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetRepayReportInfo',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetRepayReportInfoReq,
  xcommon_collection_pb.GetRepayReportInfoResp,
  /**
   * @param {!proto.xcommon.GetRepayReportInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetRepayReportInfoResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRepayReportInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetRepayReportInfoResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRepayReportInfoResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getRepayReportInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRepayReportInfo',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRepayReportInfo,
      callback);
};


/**
 * @param {!proto.xcommon.GetRepayReportInfoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRepayReportInfoResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getRepayReportInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRepayReportInfo',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRepayReportInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRobotCorpusMarkCaseListReq,
 *   !proto.xcommon.GetRobotCorpusMarkCaseListResp>}
 */
const methodDescriptor_CollectionService_GetRobotCorpusMarkCaseList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetRobotCorpusMarkCaseList',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetRobotCorpusMarkCaseListReq,
  xcommon_collection_pb.GetRobotCorpusMarkCaseListResp,
  /**
   * @param {!proto.xcommon.GetRobotCorpusMarkCaseListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetRobotCorpusMarkCaseListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetRobotCorpusMarkCaseListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRobotCorpusMarkCaseListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getRobotCorpusMarkCaseList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRobotCorpusMarkCaseList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRobotCorpusMarkCaseList,
      callback);
};


/**
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRobotCorpusMarkCaseListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getRobotCorpusMarkCaseList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRobotCorpusMarkCaseList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRobotCorpusMarkCaseList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRobotCorpusMarkCaseReq,
 *   !proto.xcommon.GetRobotCorpusMarkCaseResp>}
 */
const methodDescriptor_CollectionService_GetRobotCorpusMarkCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetRobotCorpusMarkCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.GetRobotCorpusMarkCaseReq,
  xcommon_collection_pb.GetRobotCorpusMarkCaseResp,
  /**
   * @param {!proto.xcommon.GetRobotCorpusMarkCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.GetRobotCorpusMarkCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetRobotCorpusMarkCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRobotCorpusMarkCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getRobotCorpusMarkCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRobotCorpusMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRobotCorpusMarkCase,
      callback);
};


/**
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRobotCorpusMarkCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getRobotCorpusMarkCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetRobotCorpusMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetRobotCorpusMarkCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveRobotCorpusMarkCaseReq,
 *   !proto.xcommon.SaveRobotCorpusMarkCaseResp>}
 */
const methodDescriptor_CollectionService_SaveRobotCorpusMarkCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveRobotCorpusMarkCase',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.SaveRobotCorpusMarkCaseReq,
  xcommon_collection_pb.SaveRobotCorpusMarkCaseResp,
  /**
   * @param {!proto.xcommon.SaveRobotCorpusMarkCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.SaveRobotCorpusMarkCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveRobotCorpusMarkCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveRobotCorpusMarkCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveRobotCorpusMarkCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveRobotCorpusMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveRobotCorpusMarkCase,
      callback);
};


/**
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveRobotCorpusMarkCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveRobotCorpusMarkCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveRobotCorpusMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveRobotCorpusMarkCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOcrMarkTicketListReq,
 *   !proto.xcommon.GetOcrMarkTicketListResp>}
 */
const methodDescriptor_CollectionService_GetOcrMarkCaseList = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetOcrMarkCaseList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetOcrMarkTicketListReq,
  xcommon_ticket_pb.GetOcrMarkTicketListResp,
  /**
   * @param {!proto.xcommon.GetOcrMarkTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetOcrMarkTicketListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOcrMarkTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetOcrMarkTicketListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOcrMarkTicketListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getOcrMarkCaseList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOcrMarkCaseList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOcrMarkCaseList,
      callback);
};


/**
 * @param {!proto.xcommon.GetOcrMarkTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOcrMarkTicketListResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getOcrMarkCaseList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOcrMarkCaseList',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOcrMarkCaseList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOcrMarkCaseReq,
 *   !proto.xcommon.GetOcrMarkCaseResp>}
 */
const methodDescriptor_CollectionService_GetOcrMarkCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/GetOcrMarkCase',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetOcrMarkCaseReq,
  xcommon_ticket_pb.GetOcrMarkCaseResp,
  /**
   * @param {!proto.xcommon.GetOcrMarkCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetOcrMarkCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOcrMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetOcrMarkCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOcrMarkCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.getOcrMarkCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOcrMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOcrMarkCase,
      callback);
};


/**
 * @param {!proto.xcommon.GetOcrMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOcrMarkCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.getOcrMarkCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/GetOcrMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_GetOcrMarkCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveOcrMarkCaseReq,
 *   !proto.xcommon.SaveOcrMarkCaseResp>}
 */
const methodDescriptor_CollectionService_SaveOcrMarkCase = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/SaveOcrMarkCase',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveOcrMarkCaseReq,
  xcommon_ticket_pb.SaveOcrMarkCaseResp,
  /**
   * @param {!proto.xcommon.SaveOcrMarkCaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveOcrMarkCaseResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveOcrMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveOcrMarkCaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveOcrMarkCaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.saveOcrMarkCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveOcrMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveOcrMarkCase,
      callback);
};


/**
 * @param {!proto.xcommon.SaveOcrMarkCaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveOcrMarkCaseResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.saveOcrMarkCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/SaveOcrMarkCase',
      request,
      metadata || {},
      methodDescriptor_CollectionService_SaveOcrMarkCase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ApplyFrozenInterestReq,
 *   !proto.xcommon.ApplyFrozenInterestResp>}
 */
const methodDescriptor_CollectionService_ApplyFrozenInterest = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/ApplyFrozenInterest',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.ApplyFrozenInterestReq,
  xcommon_collection_pb.ApplyFrozenInterestResp,
  /**
   * @param {!proto.xcommon.ApplyFrozenInterestReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.ApplyFrozenInterestResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ApplyFrozenInterestReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ApplyFrozenInterestResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ApplyFrozenInterestResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.applyFrozenInterest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/ApplyFrozenInterest',
      request,
      metadata || {},
      methodDescriptor_CollectionService_ApplyFrozenInterest,
      callback);
};


/**
 * @param {!proto.xcommon.ApplyFrozenInterestReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ApplyFrozenInterestResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.applyFrozenInterest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/ApplyFrozenInterest',
      request,
      metadata || {},
      methodDescriptor_CollectionService_ApplyFrozenInterest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CreatePaymentLinkReq,
 *   !proto.xcommon.CreatePaymentLinkResp>}
 */
const methodDescriptor_CollectionService_CreatePaymentLink = new grpc.web.MethodDescriptor(
  '/ticketepb.CollectionService/CreatePaymentLink',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.CreatePaymentLinkReq,
  xcommon_collection_pb.CreatePaymentLinkResp,
  /**
   * @param {!proto.xcommon.CreatePaymentLinkReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.CreatePaymentLinkResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CreatePaymentLinkReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CreatePaymentLinkResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CreatePaymentLinkResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.CollectionServiceClient.prototype.createPaymentLink =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.CollectionService/CreatePaymentLink',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CreatePaymentLink,
      callback);
};


/**
 * @param {!proto.xcommon.CreatePaymentLinkReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CreatePaymentLinkResp>}
 *     Promise that resolves to the response
 */
proto.ticketepb.CollectionServicePromiseClient.prototype.createPaymentLink =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.CollectionService/CreatePaymentLink',
      request,
      metadata || {},
      methodDescriptor_CollectionService_CreatePaymentLink);
};


module.exports = proto.ticketepb;

